import { getUser, updateUser } from '@/calls/user';
import { ApiFatalError, ApiInvalidParamError } from '@/errors/errors';

const user = {
  namespaced: true,
  state: {
    lang:'',
    requests: 0,
    form: null,
    item: null,
    error: false,
    badParams: false,
    fieldsErrors: {},
    fields: {},
    newPassword: '',
    tempScore: null
  },
  mutations: {
    setForm(state, el) {
      state.form = el;
    },
    setItem(state, item) {
      item.success = item.success ?? 0
      state.item = item;
    },
    resetItem(state) {
      state.item = null;
    },
    setFields(state, item) {
      state.fields = { ...item };
    },
    resetFields(state) {
      state.Fields = {};
    },
    updateField(state, { type, value }) {
      state.fields[type] = value;
    },
    updatePassword(state, value) {
      state.newPassword = value;
    },
    resetPassword(state) {
      state.newPassword = '';
    },
    setError(state, flag) {
      state.error = flag;
    },
    setBadParams(state, flag) {
      state.badParams = flag;
    },
    setFieldsErrors(state, object) {
      state.fieldsErrors = object;
    },
    increaseRequests(state) {
      state.requests += 1;
    },
    decreaseRequests(state) {
      state.requests -= 1;
    },
    setTempScore(state, value) {
      state.tempScore = value;
    },
    setLang(state, value) {
      state.lang = value;
    }
  },
  actions: {
    async get({ commit }, exhibitionId) {
      commit('increaseRequests');
      try {
        const response = await getUser(exhibitionId);
        commit('setItem', response);
      } catch (e) {
        commit('setItem', null);
      }
      commit('decreaseRequests');
    },
    async update({ commit, state }) {
      commit('increaseRequests');
      commit('setError', false);
      try {
        commit('setError', false);
        commit('setBadParams', false);
        const response = await updateUser(new FormData(state.form));
        commit('decreaseRequests');
        // console.log('desactivate',response', response);
      } catch (e) {
        if (e instanceof ApiInvalidParamError) {
          commit('setBadParams', true);
          commit('setFieldsErrors', e.badParams);
          console.error('Account update fatal error bad param', e.response);
        } else if (e instanceof ApiFatalError) {
          commit('setError', true);
          console.error('Account update fatal error', e.response);
        } else {
          commit('setError', true);
          console.error('Account update other fatal error', e.message);
        }
        commit('decreaseRequests');
        throw e;
      }
    },
    reset({ commit }) {
      commit('resetItem');
    },
    updateTempScore({ commit }, value) {
      commit('setTempScore', value);
    }
  }
};

export default user;
